import React from 'react'

import { Container, DottedLine } from './TimelineDottedLine.styled'

export const TimelineDottedLine = ({ direction = 'rightToLeft', ...props }) => (
  <Container {...props}>
    <DottedLine direction={direction} />
  </Container>
)
